const state = {
    error: null,
    // billing-fase5-salida-planes: planes activos (de `GET /bo/platform-plans`)
    // para saber qué plan desbloquea cada feature o tope. Se carga una vez
    // por sesión.
    planCatalog: [],
    // Modal "Pásate a…": null o { kind: "feature" | "limit", ... }.
    upgradePrompt: null
};

export default state;
